import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { getDefaultTimeZone } from 'src/app/store/masterSetup'
import dayjs from 'dayjs'
import { getUserProfile } from 'src/app/store/auth'

export const useDatePicker = () => {
  const defaultTimeZone = useSelector(getDefaultTimeZone)
  const userProfile = useSelector(getUserProfile)

  const getDatePickerDate = useCallback(
    (date: dayjs.ConfigType): dayjs.Dayjs => {
      return dayjs(date).tz(defaultTimeZone?.code, true)
    },
    [defaultTimeZone],
  )

  const getCurrentDate = useCallback((): dayjs.Dayjs => {
    return dayjs().tz(userProfile?.client?.timeZoneId ?? defaultTimeZone?.code)
  }, [defaultTimeZone, userProfile])

  const timeZoneId = userProfile?.client?.timeZoneId ?? defaultTimeZone?.code
  return { getDatePickerDate, getCurrentDate, timeZoneId }
}
